
define('text!common/views/commercial/ad-slot.html',[],function () { return '<div id="dfp-ad--<%=name%>"\n    class="js-ad-slot ad-slot ad-slot--dfp ad-slot--<%=normalisedName%><%=types%>"\n    data-link-name="ad slot <%=name%>"\n    data-test-id="ad-slot-<%=name%>"\n    data-name="<%=name%>"\n    <%=sizeMappings%>></div>\n';});

